import React, { useState } from "react";
import { getIn } from "formik";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { InputLabel, TextField, Typography, Box } from "@mui/material";
import moment from "moment";

export const TimeFormField = ({
  field,
  form,
  label,
  minTime,
  maxTime,
  onValueChange,
  isRequired,
  disabled,
  ...props
}) => {
  const errorText = getIn(form.touched, field.name) && getIn(form.errors, field.name);
  const [inputValue, setInputValue] = useState(field.value ? moment(field.value).format("HH:mm") : null);

  return (
    <Box>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        {label && (
          <InputLabel shrink htmlFor={field.name}>
            <Typography variant="body1" sx={{ textTransform: "capitalize" }}>
              {label}
              {isRequired && (
                <Typography variant="body1" color="error" component="span">
                  {" *"}
                </Typography>
              )}
            </Typography>
          </InputLabel>
        )}
        <TimePicker
          onChange={(value) => {
            const momentValue = moment(value);
            if (momentValue.isValid()) {
              form.setFieldValue(field.name, momentValue.format("HH:mm"), true);
              onValueChange?.(momentValue.format("HH:mm"));
              setInputValue(momentValue.format("HH:mm"));
            } else {
              form.setFieldValue(field.name, null, true);
              setInputValue(null);
            }
          }}
          minTime={minTime ? moment(minTime, "HH:mm") : null}
          maxTime={maxTime ? moment(maxTime, "HH:mm") : null}
          value={field.value ? moment(field.value, "HH:mm") : null}
          sx={{
            backgroundColor: "#F7FAFF",
            border: "1px solid #4169E1",
            borderRadius: "5px",
            width: "100%",
            padding: "0",
            "& fieldset": { border: "none" },
            "& .MuiInputBase-input": { padding: "10px 14px" },
            "& .css-1dune0f-MuiInputBase-input-MuiOutlinedInput-input": { fontSize: "12px" }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              id={field.name}
              error={Boolean(errorText)}
              helperText={errorText}
              fullWidth
              {...field}
              {...props}
              label={undefined}
              sx={{
                "label + &": {
                  marginTop: -0.7,
                },
                mb: 1.5,
              }}
              disabled={disabled}
            />
          )}
          inputFormat="HH:mm"
          disabled={disabled}
        />
      </LocalizationProvider>
      <Typography variant="body2" fontSize={"10px"} color="#DC143C">
        {errorText}
      </Typography>
    </Box>
  );
};
